import * as React from "react";
import styled from "styled-components";
import { Icon } from "components/common";
import { DataWell } from "security-app/components/common";
import { Row, Col } from "security-app/components/common/FormBaseStyles";
import { useGetPriorities } from "security-app/hooks/useAssetsAPI";
import MachineDetails from "./MachineDetails";
import GeoInfo from "./GeoInfo";
import CustomFields from "./CustomFields";
import RiskPriorityHeader from "../RiskPriorityHeader";
const Description = styled.p`
  white-space: pre-wrap;
`;
function MachineData({ machineAsset }) {
  var _a, _b;
  const operatingSystem = /* @__PURE__ */ new Set();
  machineAsset.vulnerabilities.forEach((vuln) => {
    if (vuln.os) operatingSystem.add(vuln.os);
  });
  const { priorities } = useGetPriorities();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    RiskPriorityHeader,
    {
      riskScore: machineAsset.risk_score_normalized,
      priorityValue: machineAsset.priority,
      priorities
    }
  ), /* @__PURE__ */ React.createElement(DataWell, null, /* @__PURE__ */ React.createElement(Row, { "aria-label": "Operating system well" }, /* @__PURE__ */ React.createElement(Icon, { name: "computer", type: "regular" }), /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement("small", null, "Operating System"), /* @__PURE__ */ React.createElement("span", null, [...operatingSystem].join(", ") || /* @__PURE__ */ React.createElement("i", null, "No Operating System Information"))))), /* @__PURE__ */ React.createElement(MachineDetails, { machineAsset }), /* @__PURE__ */ React.createElement(DataWell, null, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement("small", null, "Description"), /* @__PURE__ */ React.createElement(Description, null, machineAsset.details.description || /* @__PURE__ */ React.createElement("i", null, "No description")))), /* @__PURE__ */ React.createElement("strong", null, "Geo Information"), /* @__PURE__ */ React.createElement(GeoInfo, { geoInfo: (_a = machineAsset.details) == null ? void 0 : _a.geo_info }), /* @__PURE__ */ React.createElement("strong", null, "Custom Fields"), /* @__PURE__ */ React.createElement(CustomFields, { customFields: (_b = machineAsset.details) == null ? void 0 : _b.custom_fields }));
}
export default MachineData;
